import Image from 'next/image';

import vinDoorImage from '../../../../../assets/images/vin-door.png';
import vinWindshieldImage from '../../../../../assets/images/vin-windshield.png';
import {
  Part,
  Heading,
  StyledButton,
  Caption,
  Text,
  SubText,
  OtherSourcesSection,
  OtherSourcesHeading,
  SourceList,
  SourceItem,
  SourceTitle,
  SourceDescription
} from './styles';

type WhereIsMyVinContentProps = {
  closeModal?: () => void;
};

const WhereIsMyVinContent = ({ closeModal }: WhereIsMyVinContentProps) => (
  <>
    <Heading>Where is my VIN?</Heading>
    <Part>
      <Image src={vinWindshieldImage} alt="vin in windshield" />
      <Caption>
        <Text>Driver side dashboard</Text>
        <SubText>Where the dashboard meets the windshield</SubText>
      </Caption>
    </Part>
    <Part>
      <Image src={vinDoorImage} alt="vin in door" />
      <Caption>
        <Text>Driver side door jamb</Text>
        <SubText>On the inside frame of the driver&apos;s door</SubText>
      </Caption>
    </Part>
    <OtherSourcesSection>
      <OtherSourcesHeading>Other ways to find your VIN</OtherSourcesHeading>
      <SourceList>
        <SourceItem>
          <SourceTitle>Vehicle registration:</SourceTitle>{' '}
          <SourceDescription>
            Your state registration paperwork, often available through your DMV&apos;s website or
            app.
          </SourceDescription>
        </SourceItem>
        <SourceItem>
          <SourceTitle>Insurance documents:</SourceTitle>{' '}
          <SourceDescription>
            Your auto insurance policy, ID card or online account.
          </SourceDescription>
        </SourceItem>
        <SourceItem>
          <SourceTitle>Title or lien documents:</SourceTitle>{' '}
          <SourceDescription>
            On your electronic or paper title. You can also access it from your lender&apos;s
            account.
          </SourceDescription>
        </SourceItem>
      </SourceList>
    </OtherSourcesSection>
    <StyledButton className="where-is-my-vin" variant="primary" size="md" onClick={closeModal}>
      Okay
    </StyledButton>
  </>
);

export default WhereIsMyVinContent;
